module.exports = __webpack_public_path__ + "static/media/zeplin.82468d69.svg";